// ----------------------------------------------------------------------------
// Template: Cart
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import './ajax-cart-page';
import 'snippets/cart-js/cart-js';
import 'snippets/mini-cart/mini-cart';
import 'snippets/tooltip/tooltip';
import 'snippets/bold-upsell/bold-upsell';

import 'sections/header/header';
import 'sections/footer/footer';

// Styles
import './_cart.scss';


$(window).on("load", function()
{
    if($('.button-collection--cart-page').length) {
        $('.button-collection--cart-page').each(function(){

            if($(this).hasClass('hidden')) {
                $(this).removeClass('hidden');
            }
        })
    }
})
